import { createSlice } from '@reduxjs/toolkit';

import { getNotificationPreferences, setNotificationPreferences, updateNotificationPreference } from './actions';

const initialState = {
  preferences: {},
  loading: false,
  error: false,
};

const notificationsStore = createSlice({
  name: 'notifications',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setNotificationPreferences, (state, { payload }) => {
      state.preferences = payload;
    });

    builder.addCase(getNotificationPreferences.pending, (state) => {
      state.loading = true;
      state.error = false;
    });

    builder.addCase(getNotificationPreferences.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.preferences = payload;
    });

    builder.addCase(getNotificationPreferences.rejected, (state, { error }) => {
      state.loading = false;
      state.error = error.message || true;
    });

    builder.addCase(updateNotificationPreference.fulfilled, (state, { payload }) => {
      state.preferences = payload;
      state.error = false;
    });

    builder.addCase(updateNotificationPreference.rejected, (state, { error }) => {
      state.error = error.message || true;
    });
  },
});

export default notificationsStore.reducer;
